<script>
export default {
  name: 'ChipsCombobox',
  props: {
    label: {
      type: String,
      default: () => '',
    },
    itemValue: {
      type: String,
      default: () => 'id',
    },
    itemDisplay: {
      type: Function,
      default: o => o,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    'search',
    'update:modelValue',
  ],
  methods: {
    onSearch (event) {
      this.$emit('search', event.target.value)
    },
    onUpdateModelValue (newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
<template>
  <v-combobox
    :model-value="modelValue"
    multiple
    clear-on-select
    hide-selected
    closable-chips
    color="secondary"
    :label="label"
    :item-title="itemDisplay"
    :item-value="itemValue"
    :hide-details="hideDetails"
    @keydown="onSearch"
    @update:model-value="onUpdateModelValue"
  >
    <template v-slot:chip="{ props }">
      <v-chip
        v-bind="props"
        variant="elevated"
        color="secondary"
      />
    </template>
  </v-combobox>
</template>
